import { converterNumeroBR } from '../lib/textoBR'
import { converterPercentualTributo } from './validacao'

// Os campos do PRODUTO (cadastro e fiscais), do jeito que viajam no payload da
// importacao. Mesma regra da caixa fechada (payloadCaixaFechada.ts):
//
// ⭐ R13 estendida a todos os campos (decisao dela em 15/10/2026, depois de
// medir na DEMO que reimportar so Codigo/Descricao/Preco APAGAVA unidade,
// categoria, NCM e impostos): COLUNA NAO MAPEADA NAO MEXE NO QUE ESTA GRAVADO.
//   chave AUSENTE = a coluna nao foi mapeada: a edge pula o campo.
//   null          = a coluna foi mapeada e a celula veio vazia: apague.
//   valor         = grave.
//
// `aplicarMapa` (validacao.ts) so escreve as chaves que o mapa cita, entao
// `'x' in campos` e exatamente "a coluna x foi mapeada".
export interface CamposProduto {
  unidade?: string | null
  categoria?: string | null
  linha?: string | null
  fabricante?: string | null
  foto_url?: string | null
  observacoes?: string | null
  ncm?: string | null
  ipi_pct?: number | null
  icms_pct?: number | null
  st_pct?: number | null
  pis_cofins_pct?: number | null
  estoque?: number | null
}

const TEXTOS = ['unidade', 'categoria', 'linha', 'fabricante', 'foto_url', 'observacoes', 'ncm'] as const
const TRIBUTOS = ['ipi_pct', 'icms_pct', 'st_pct', 'pis_cofins_pct'] as const

export function camposProduto(campos: Record<string, string>): CamposProduto {
  const saida: CamposProduto = {}
  // `|| null`: string vazia viraria um texto em branco no banco, que le
  // diferente de "nao informado".
  for (const k of TEXTOS) if (k in campos) saida[k] = campos[k] || null
  // `converterPercentualTributo` devolve `undefined` para vazio e `null` para
  // sujo; o `?? null` achata os dois. Seguro: so roda sobre linhas validas.
  for (const k of TRIBUTOS) if (k in campos) saida[k] = converterPercentualTributo(campos[k] ?? '') ?? null
  if ('estoque' in campos) saida.estoque = campos.estoque ? converterNumeroBR(campos.estoque) : null
  return saida
}
